import Blue from "../core";

new Blue({
	name: 'Event Schedule',
	selector: ".event-schedule",
	setup(eventSchedule) {
    const items = [...eventSchedule.querySelectorAll('.event-schedule__session')];

    items.forEach(container => {
      let trigger = container.querySelector('.event-schedule__trigger')
      let content = container.querySelector('.event-schedule__content')
      let config = {
        container,
        trigger,
        content,
      }
			new this.$toggle(config);
    });
	}
});